import { PULSE_BRIDGE_URL } from "../constants";

export const buyAgain = (customerId: number) =>
  `${PULSE_BRIDGE_URL}/v1/customers/${customerId}/recommendations/buy-again`;

export const forYou = (customerId: number) =>
  `${PULSE_BRIDGE_URL}/v1/customers/${customerId}/recommendations/for-you`;

export const topProducts = `${PULSE_BRIDGE_URL}/v1/recommendations/products/top`;

export const relatedProducts = (productId: number | string) =>
  `${PULSE_BRIDGE_URL}/v1/products/${productId}/recommendations/related`;

export const similarProducts = (productId: number | string) =>
  `${PULSE_BRIDGE_URL}/v1/products/${productId}/similar`;

export const mostPurchasedCategory = `${PULSE_BRIDGE_URL}/api/v1/recombee/most-purchased-category`;

export const mostPurchasedHub = `${PULSE_BRIDGE_URL}/api/v1/recombee/most-purchased-hub`;

export const recentlyViewedCustomer = (customerId: number) =>
  `${PULSE_BRIDGE_URL}/v1/customers/${customerId}/recently-viewed`;

export const recentlyViewedSession = (sessionId: string) =>
  `${PULSE_BRIDGE_URL}/v1/sessions/${encodeURIComponent(sessionId)}/recently-viewed`;

export const mostViewed = `${PULSE_BRIDGE_URL}/v1/recommendations/products/most-viewed`;

export const fromViewsCustomer = (customerId: number) =>
  `${PULSE_BRIDGE_URL}/v1/customers/${customerId}/recommendations/from-views`;

export const fromViewsSession = (sessionId: string) =>
  `${PULSE_BRIDGE_URL}/v1/sessions/${encodeURIComponent(sessionId)}/recommendations/from-views`;
